// Central config for the landing page. Mirrors BDK reference palette (ventas.css).
export const SITE_URL = "https://www.creativosbdk.com";

export const BDK = {
  companyLegalName: "BDKSISTEMAS S.A. DE C.V.",
  companyTagline: "Lo mejor en informática y puntos de venta.",
  publicWeb: "www.bdksistemas.com.mx",
  publicEmail: "ventas@bdksistemas.com.mx",
  whatsapp: "528132814080",
  whatsappDisplay: "+52 81 3281 4080",
  whatsappDefaultMessage:
    "Hola, quiero información sobre páginas web de BDKSISTEMAS. Me interesa ver una propuesta para mi negocio.",
  logos: {
    redBlack: `${process.env.PUBLIC_URL}/img/logo-rojo-negro.png`,
    redWhite: `${process.env.PUBLIC_URL}/img/logo-rojo-blanco.png`,
    white: `${process.env.PUBLIC_URL}/img/logo-blanco.png`,
    anniversary14: `${process.env.PUBLIC_URL}/img/bdk-14-aniversario.png`,
  },
  colors: {
    red: "#D90020",
    redDark: "#AA0019",
    ink: "#111218",
    ink2: "#191A22",
    paper: "#F7F7F8",
    white: "#FFFFFF",
    muted: "#666873",
    line: "#E3E3E7",
    whatsapp: "#25D366",
  },
  portfolio: [
    {
      name: "Gimnasios",
      description:
        "Landing premium para gimnasios con enfoque de conversión y WhatsApp directo.",
      url: "https://www.demo-gym.bdksistemas.com.mx/",
      tag: "Landing conversión",
      image: `${process.env.PUBLIC_URL}/img/portfolio-gimnasios.jpg`,
    },
    {
      name: "Salones de belleza y spas",
      description:
        "Sitio corporativo claro y moderno para presentar servicios y facilitar el contacto.",
      url: "https://sherin-spa-demo.vercel.app/",
      tag: "Landing page",
      image: `${process.env.PUBLIC_URL}/img/portfolio-salones.jpg`,
    },
    {
      name: "Venta de servicios",
      description:
        "Landing enfocada en membresías, promociones y captación de prospectos.",
      url: "https://www.landing.bdkgym.com/",
      tag: "Landing captación",
      image: `${process.env.PUBLIC_URL}/img/portfolio-servicios.jpg`,
    },
    {
      name: "Discada ¡La Qué Sabrosa!",
      description:
        "Landing para catering de eventos, con panel administrativo a la medida para cotizaciones, control de eventos, pagos y gastos.",
      url: "https://www.laquesabrosa.com/",
      tag: "Landing + panel admin",
      image: `${process.env.PUBLIC_URL}/img/portfolio-laquesabrosa.jpg`,
    },
    {
      name: "Menú Digital",
      description:
        "Menú digital con carrito de pedidos que envía el pedido directo a WhatsApp. (Demo)",
      url: "https://bdk-menu-digital-demo.vercel.app/",
      tag: "Landing conversión",
      image: `${process.env.PUBLIC_URL}/img/portfolio-menu-digital.jpg`,
    },
    // Nota: las tarjetas "Próximamente" (restaurantes, quintas) se retiraron
    // de la sección de prueba social; se reincorporan cuando exista demo real.
  ],
};

export const waUrl = (message) => {
  const text = encodeURIComponent(message || BDK.whatsappDefaultMessage);
  return `https://wa.me/${BDK.whatsapp}?text=${text}`;
};

// Feature flag: build-time switch for the NEXO chat widget replacing the
// WhatsApp float button (see docs/superpowers/specs/2026-09-05-nexo-design.md,
// section N and X). Flip REACT_APP_NEXO_ENABLED back to "false" to roll back
// instantly without touching WhatsAppFloat/ContactForm.
export const NEXO_ENABLED = process.env.REACT_APP_NEXO_ENABLED === "true";
